export const commentConstants = {
    COMMENT_GET: 'comment/get',
    COMMENT_CLAER: 'comment/clear',
    COMMENT_ADD: 'comment/add',
}